{
  "adminSignInLink": {
    "body": "I-click ang button sa ibaba para ma-access ang iyong Pointcare admin portal.",
    "cta": "Mag-sign in sa admin",
    "greeting": "Kumusta,",
    "ignore": "Kung hindi ka humiling ng admin access, ligtas mong maaaring balewalain ang email na ito.",
    "linkFallback": "Kung hindi gumagana ang button, kopyahin at i-paste ang link na ito:",
    "signoff": "Salamat,\nAng Pointcare team",
    "subject": "Ang iyong Pointcare admin sign-in link"
  },
  "reset": {
    "body": "Nakatanggap kami ng kahilingan na i-reset ang password ng iyong Pointcare account. I-click ang button sa ibaba para gumawa ng bago.",
    "cta": "I-reset ang aking password",
    "greeting": "Kumusta,",
    "ignore": "Kung hindi ka humiling nito, ligtas mong maaaring balewalain ang email na ito. Hindi magbabago ang iyong password.",
    "signoff": "Salamat,\nAng Pointcare team",
    "subject": "I-reset ang iyong Pointcare password"
  },
  "signInLink": {
    "body": "I-tap ang button sa ibaba para kumpirmahin ang iyong email at i-set up ang iyong Pointcare account.",
    "cta": "Kumpirmahin ang aking email",
    "greeting": "Kumusta,",
    "ignore": "Hindi ka nag-sign up sa Pointcare? Pwede mong balewalain ang email na ito.",
    "linkFallback": "Kung hindi gumagana ang button, kopyahin at i-paste ang link na ito:",
    "signoff": "Salamat,\nAng Pointcare team",
    "subject": "Kumpirmahin ang iyong email para sa Pointcare"
  }
}
